<template>
  <ODialog ref="dialog" hide-when-loading>
    <v-card v-if="client != null">
      <ODialogBar title="Desassociar Módulo de Veículo" @close="dismiss" />

      <template v-if="vehicle == null">
        <v-card-text class="pa-6">
          Este módulo não está associado a nenhum veículo.
        </v-card-text>
        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn text large @click="dismiss">OK</v-btn>
        </v-card-actions>
      </template>

      <template v-else>
        <div class="px-4 py-6">
          <div class="grey lighten-3 pa-3 mb-3 rounded-lg">
            <OCapCont label="Módulo">
              <b>{{ clientId }}</b>
            </OCapCont>
          </div>
          <div class="grey lighten-3 pa-3 mb-3 rounded-lg">
            <OCapCont label="Veículo">
              <b>{{ vehicle.code }}</b>
              <span v-if="vehicle.extraCode != null"
                >({{ vehicle.extraCode }})</span
              >
              no sistema
              <b>{{ vehicle.org.name }}</b>
            </OCapCont>
          </div>
          <div class="pa-6">
            <div class="amber lighten-2 rounded-lg d-flex pa-2 align-center space-between gap-4">
              <div style="line-height: 32px" class="w-2 h-2 text-center grow-0 shrink-0"><v-icon>mdi-alert</v-icon></div>
              <div>
                Lembre-se de verificar se o rawdata do módulo foi coletado
                completamente antes de prosseguir!
              </div>
            </div>
          </div>
        </div>
        <ODialogButtons
          class="pa-6"
          txtApply="Sim, desassociar"
          txtCancel="Não, cancelar"
          @apply="apply"
          @cancel="dismiss"
        />
      </template>
    </v-card>
  </ODialog>
</template>

<script>
import { Client, Vehicle, go } from '@/models'

export default {
  data() {
    return this.reset()
  },
  computed: {},
  methods: {
    reset() {
      return {
        clientId: null,
        client: null,
        vehicle: null
      }
    },

    dismiss() {
      this.$refs.dialog.$dismiss()
    },

    open({ clientId }) {
      Object.assign(this, this.reset())
      this.clientId = clientId
      this.$refs.dialog.$loading(() => this.fetchData())
      return this.$refs.dialog.$open()
    },

    async fetchData() {
      let ci = await Client.findById(this.clientId)
      if (ci.vehicleId != null) {
        let vehicle = await Vehicle.findByOrgAndId(
          ci.organizationId,
          ci.vehicleId
        )
        this.vehicle = vehicle
      }
      this.client = ci
    },

    apply() {
      this.$rootLoading(async () => {
        let body = {}
        await go.post(`/clients/${this.clientId}/dissociate`, body)
        this.$snack('Desassociado com sucesso')

        this.$refs.dialog.$apply('RELOAD')
      })
    }
  }
}
</script>

<style></style>
